import { UserEvent } from 'src/app/content-management/shared/enums/user-event';

export class UserAlert {
  constructor(
    public contentId?: string,
    public username?: string,
    public action?: UserEvent
  ) {}
}
